
<template>
    <div >
        <Toolbar :editor="taskEditor" :defaultConfig="toolbarConfig"    style="border: 1px solid #dddddd"/>
        <Editor style="height: 320px; overflow-y: hidden;border: 1px solid #dddddd;border-top: none"
                v-model="wangEditorValue" :defaultConfig="editorConfig"   @onCreated="onCreated"  @customPaste="customPaste"  @onChange="onChange"/>
    </div>
</template>
<script>
import { uploadImg ,getOSSData} from '@/utils/uploadOss'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
    name: 'WangEditor',
    components:{
        Editor,
        Toolbar
    },
    props: {
        wangEditorText: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            wangEditorValue:'',
            taskEditor:null,
            toolbarConfig: {
                toolbarKeys: [
                    'bold',
                    'clearStyle',
                    'color',
                    'bgColor',
                    '|', // 分隔线
                    {
                        key: 'group-image', // 以 group 开头的键值，表示这是一个菜单组
                        title: '图片',
                        menuKeys: ['uploadImage', 'deleteImage', 'editImage']
                    },
                    {
                        key: 'group-video',
                        title: '视频',
                        menuKeys: [ 'uploadVideo']
                    },
                    'undo', // 撤销
                    'redo' // 重做

                    // 其他菜单键值和分组...
                ]
            },
            editorConfig: {
                placeholder: '请输入内容',
                MENU_CONF:{
                    uploadImage:{
                        customUpload: async (file, insertFn) => {
                            let resultUrl = await this.upalyOss(file);
                            insertFn(resultUrl);
                        },
                    },
                    uploadVideo: {
                        customUpload: async (file, insertFn) => {
                            let resultUrl = await this.upalyOss(file);
                            insertFn(resultUrl);
                        },
                   },
                }
             },
        }
    },
    created () {
    },
    mounted () {


    },
    methods: {
        onCreated (editor) {
            this.taskEditor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            console.log(this.wangEditorText)
            this.taskEditor.setHtml(this.wangEditorText);  //赋值
        },
        // 上传图片
        upalyOss(file){
            let that = this
            return new Promise((resolve) => {
                uploadImg(file,20).then(res => {
                    that.$message.success('上传成功')

                    resolve(res.file_path)
                }).catch(() => {
                    that.loading = false
                })

            })

        },

        // 粘贴
        async customPaste(editor, event, callback){
            // const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
            const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
            const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
            let files = event.clipboardData.files
            if(files && files[0]){
                await this.upalyOss(files[0])
            }
            // 自定义插入内容
            editor.insertText(text)
            // 返回 false ，阻止默认粘贴行为
            event.preventDefault()
            callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
        },

        onChange(editor){
            const html = editor.getHtml();
            // this.$emit('input',html);
        },

    },
    watch:{

    },
}
</script>
<style lang="scss" scoped>
::v-deep .w-e-text-container p{
    margin: 0 !important;
}
</style>
